import React, { Fragment } from "react";

import Page from "../../components/Page";
import EmployeeList from "../../components/EmployeeList";
import CompanyEmployeeList from "../../components/CompanyEmployeeList";
import EmployeeListPerCompany from "../../components/EmployeeListPerCompany";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

let credentials = JSON.parse(localStorage.getItem("credentials"));

const EmployeePage = () => (
  <Page title="Medewerkers">
    <Fragment>
      <CenteredPageContentContainer>
        {(() => {
          switch (credentials.user.type) {
            case "PERSON":
              return (
                <PaperContainer title="Medewerkers">
                  <EmployeeList />
                </PaperContainer>
              );
            case "EMPLOYEE":
              return (
                <EmployeeListPerCompany
                  employeeEmail={credentials.user.email}
                />
              );
            default:
              return (
                <PaperContainer title="Medewerkers">
                  <CompanyEmployeeList company={credentials.user.email} />
                </PaperContainer>
              );
          }
        })()}
      </CenteredPageContentContainer>
      <Fab
        variant="circular"
        color="primary"
        style={{ position: "fixed", bottom: 40, right: 40 }}
        onClick={() => {
          window.location.href = `/employee/create`;
        }}
      >
        <AddIcon />
      </Fab>
    </Fragment>
  </Page>
);

export default EmployeePage;



// WEBPACK FOOTER //
// ./src/pages/Employee/EmployeePage.js